import GetUrls from 'ts/enums/Url'

interface Response {
    [key: string]: any;
}

const FormFormatter = () => {
    const Url = GetUrls();
    return {
        modifyResJava: (response: Response, url: string | undefined, traderId: string, user: any): Response => {
            const fieldMap: { [key: string]: string } = {
                "flActive": "isActive",
                "flOpenPrice": "isOpenPrice",
                "subclassId": "subClassId",
                "thorProductId": "productId",
                "price": "unitPrice",
                "name": response.productTypeId  ? "productName" : 
                url === Url.postClassAlt ? "className" :
                url === Url.postSubclassAlt ? "subClassName" : "name"
            };
            const modifiedResponse: Response = {};
            for (const key in response) {
                if (fieldMap.hasOwnProperty(key)) {
                modifiedResponse[fieldMap[key]] = response[key];
                } else {
                modifiedResponse[key] = response[key];
                }
            }
            if (response.productTypeId && url === Url.postProductAlt) {
                modifiedResponse.procurerTraderId = user.traders.length !== 0 ? [Number(traderId)] : [Number(user.traderId)];
            }
            if (url === Url.postClassAlt) {
                modifiedResponse.departmentId = 1;
            }
            
            // Only process procurerTraderId for specific URLs (NOT for class operations)
            if (url !== Url.postClassAlt && url !== Url.updateClassAlt && url !== Url.postSubclassAlt && url !== Url.updateSubclassAlt) {
                if (traderId) {
                    modifiedResponse.procurerTraderId = [Number(traderId)];
                }
                
                // Only process response.traderId if it exists and we're not dealing with class operations
                if (response.traderId && Array.isArray(response.traderId)) {
                    modifiedResponse.procurerTraderId = response.traderId.map((id: number) => Number(id));
                    delete modifiedResponse.traderId;
                } else if (response.traderId) {
                    // Handle case where traderId is a single value, not an array
                    modifiedResponse.procurerTraderId = [Number(response.traderId)];
                    delete modifiedResponse.traderId;
                }
            }
            
            return modifiedResponse;
        },
        
        // Modify the product data for Kupid Node API
        modifyMainRes: (response: Response, method: string, url: string, traderId: string | undefined, thorProductId?: string): Response => {
        console.log("THOR:",thorProductId)
        const fieldMap: { [key: string]: string } = {
            "n": "n",
        };
        const modifiedResponse: Response = {};
        for (const key in response) {
            if (
                key !== "taxTypeId" &&
                key !== "price" &&
                key !== "openPriceMax" &&
                key !== "openPriceMin" &&
                key !== "productPriceLevelId" &&
                key !== "productTaxId"
            ) {
            if (response.productTypeId === 2 && key === "productTypeId") {
                modifiedResponse.flGiftCard = 1;
            }
            if (fieldMap.hasOwnProperty(key)) {
                modifiedResponse[fieldMap[key]] = response[key];
            } else {
                modifiedResponse[key] = response[key];
              }
            }
        }
        if (method === "PUT" && "sku" in modifiedResponse) {
            delete modifiedResponse.sku;
        }
        if (thorProductId) {
            modifiedResponse.thorProductId = thorProductId;
        }
        if (traderId) {
            modifiedResponse.traderId = response.traderId;
        }
        if (response.productId) {
            modifiedResponse.productId = Number(response.productId);
        }
        return modifiedResponse;
        },

        modifyProductLayout: (response: Response, traderId: string): Response => {
            const fieldMap: { [key: string]: string } = {
            "n": "n",
        };
        const modifiedResponse: Response = {};
        for (const key in response) {
            if (key !== "layoutData") {
            if (fieldMap.hasOwnProperty(key)) {
                modifiedResponse[fieldMap[key]] = response[key];
            } else {
                modifiedResponse[key] = response[key];
            }
            }
        }
        if (traderId) {
            modifiedResponse.traderId = response.traderId;
        }
        return modifiedResponse;
        },
        filterLayoutData: (layoutData: ({ type: string; name: string; index: number; productId: number; positionId: number; } | null | undefined)[]): { productId: number; positionId: number; }[] => {
            return layoutData
            .filter((data): data is { type: string; name: string; index: number; productId: number; positionId: number; } => data !== null && data !== undefined)
            .map(({ productId, positionId }) => ({ productId, positionId }));
        },
        modifyUser: (response: Response, url: string, traderId: string | undefined): Response => {
            const fieldMap: { [key: string]: string } = { "n": "n" };
            const modifiedResponse: Response = {};
            for (const key in response) {
                if (key !== "password" && key !== "invalidLogins" && key !== "initialPassword") {
                    const mappedKey = fieldMap[key] ?? key;
                    modifiedResponse[mappedKey] = response[key];
                }
            }
            if (traderId) {
                modifiedResponse.traderId = [Number(traderId)];
            }
            return modifiedResponse;
        }
    }
}

export default FormFormatter;